import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { multiSectionFullGallerySections, firstLineOfGridTables } from './tableGallerySection';
import { predefinedTableStyles } from './tableControlsStrings.locstring.json';
import loc from 'owa-localize';
import { FormatControlId } from 'owa-ribbon-ids/lib/formatControlId';
import {
    getMenuDefinitionForControls,
    RibbonTableStylesGalleryButtonProps,
} from '@1js/acui-ribbon-like';
import { applyPredefinedStyles } from './applyPredefinedStyles';
import { PredefinedTableStyles } from './tablesEnum/predefinedTableStylesEnum';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import { getIsDarkTheme } from 'owa-fabric-theme';

export const getTablePredefinedStyleMenu = computedFn(
    (editorId: string): RibbonControlProps => {
        return {
            type: 'RibbonTableStylesPreviewGalleryProps',
            id: getComposeRibbonId(FormatControlId.PredefinedStyles, editorId).toString(),
            galleryButtons: firstLineOfGridTables(getIsDarkTheme()),
            menuLauncherLabel: loc(predefinedTableStyles),
            onGalleryButtonExecute: (parameter: {
                galleryButton: RibbonTableStylesGalleryButtonProps;
            }) => {
                applyPredefinedStyles(
                    editorId,
                    parameter.galleryButton.id as PredefinedTableStyles
                );
            },
            onMenuButtonExecute: () => {},
            expandedOptions: getGalleryMenuDefinition(editorId),
        };
    }
);

const getGalleryMenuDefinition = computedFn((editorId: string) => {
    const sections = multiSectionFullGallerySections(getIsDarkTheme());
    return getMenuDefinitionForControls([
        {
            type: 'RibbonTableStylesFullGalleryProps',
            id: getComposeRibbonId(FormatControlId.PredefinedStylesGallery, editorId).toString(),
            columns: 7,
            gallerySections: sections,
            onGalleryButtonExecute: parameter => {
                applyPredefinedStyles(
                    editorId,
                    parameter.galleryButton.id as PredefinedTableStyles
                );
            },
            positionInSet: 1,
            setSize: sections.length + 1,
        },
    ]);
});
